import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';
import { ALERTS, EMERGENCY_CALLS } from '@rsos/constants/incidentTypes';
import {
  QUEUE_FIXED_WIDTH,
  QUEUE_FULL_WIDTH,
} from '@rsos/constants/queueWidths';

const TITLE_WRAPPER_HEIGHT = 48;
const CONNECTED_UNIVERSAL_SEARCH_HEIGHT = 70;

export const Container = styled(Box).attrs(({ layout, actionBarHeight }) => ({
  backgroundColor: 'background',
  width: QUEUE_FIXED_WIDTH,
  height: `${
    layout && layout.body && layout.body.height
      ? layout.body.height - CONNECTED_UNIVERSAL_SEARCH_HEIGHT - actionBarHeight
      : layout.body.height
  }px`,
}))`
  z-index: 1;
  display: flex;
  flex-direction: column;
  @media (max-width: ${BP_LAPTOP}px) {
    width: ${p => (p.isIRP ? QUEUE_FIXED_WIDTH : QUEUE_FULL_WIDTH)};
    height: ${p => !p.isIRP && '100%'};
  }
`;

export const TitleWrapper = styled(Box).attrs({
  justify: 'center',
  width: '100%',
  height: `${TITLE_WRAPPER_HEIGHT}px`,
  padding: '16px 20px',
})`
  flex: 0 0 auto;
  border-top: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  z-index: 5;
  @media (max-width: ${BP_LAPTOP}px) {
    width: 100%;
  }
`;
export const Title = styled(Text).attrs(({ type }) => ({
  size: 'normal',
  fontWeight: 'bold',
  color:
    type === ALERTS
      ? 'states'
      : type === EMERGENCY_CALLS
        ? 'success'
        : 'primaryText',
}))``;

export const Subtitle = styled(Text).attrs({
  color: 'primaryText',
  size: 'small',
})``;

export const Content = styled.div`
  display: ${({ active }) => (active ? 'flex' : 'none')};
  flex: 1;
  min-height: 0;
  background-color: ${({ theme }) => theme.colors.background};
  flex-direction: column;
  overflow: hidden;
  ${({ theme }) => `border-right: 1px solid ${theme.colors.lightLineDivider}`};

  @media (max-width: ${BP_LAPTOP}px) {
    height: '100%';
  }
`;
